import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/utils/constants'
import { formatDateDMY } from '@/utils/date'
import type { UserStub } from '@/types/dashboard'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface HomeworkRow {
  id: number
  lesson_id: number
  student: UserStub | null
  completed_at: string | null
}

export function HomeworksToCheckWidget({ payload }: WidgetProps) {
  const { t } = useTranslation()
  const items = (payload.items ?? []) as HomeworkRow[]
  const count = Number(payload.count ?? 0)

  if (count === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.homeworks_to_check.empty" />
  }

  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <MuiLink
            component={Link}
            to={ROUTES.LESSON_DETAILS(item.lesson_id)}
            variant="body2"
            noWrap
            sx={{ flexGrow: 1, minWidth: 0 }}
          >
            {item.student?.name ?? `#${item.id}`}
          </MuiLink>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            {t('dashboard.widgets.homeworks_to_check.completedAt', {
              date: formatDateDMY(item.completed_at),
            })}
          </Typography>
        </Box>
      ))}
      {count > items.length && (
        <Typography variant="caption" color="text.secondary">
          +{count - items.length}
        </Typography>
      )}
    </Stack>
  )
}
